export default "__VITE_ASSET__Bicq5Dd9__"